// Action Type for fetch All Products
export const FETCH_PRODUCT_PENDING = 'product/fetchPending';
export const FETCH_PRODUCT_SUCCESS = 'product/fetchSuccess';
export const FETCH_PRODUCT_REJECT = 'product/fetchReject';

// Action Type for fetch Product Detail
export const FETCH_PRODUCT_DETAIL_PENDING = 'productDetail/fetchPending';
export const FETCH_PRODUCT_DETAIL_SUCCESS = 'productDetail/fetchSuccess';
export const FETCH_PRODUCT_DETAIL_REJECT = 'productDetail/fetchReject';
